export default __webpack_public_path__ + "static/index-about-bef7ab01fc7773d23084af562546079a.png";